import React from 'react'
import { IconHighlight, IconX } from '@tabler/icons-react'
import { cn } from '@/lib/utils'
import { motion, AnimatePresence } from 'framer-motion'

interface SelectedTextProps {
  text: string
  onClose: () => void
}

export const SelectedText: React.FC<SelectedTextProps> = ({ text, onClose }) => {
  // Only truncate if text exists and is longer than 150 characters
  const truncatedText = text && text.length > 150 ? text.slice(0, 150) + '...' : text || ''

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98, y: -5 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.98, y: -5 }}
      transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25,
        mass: 0.6,
        duration: 0.4
      }}
      className="mb-2 flex max-w-full items-start gap-2 overflow-hidden rounded-lg border border-amber-200 bg-amber-100/90 p-3 text-sm shadow-sm backdrop-blur-sm dark:border-amber-700 dark:bg-amber-800/90"
    >
      <IconHighlight size={16} className="mt-1 shrink-0 text-amber-500 dark:text-amber-400" />
      <p className="line-clamp-2 flex-1 break-words text-xs text-amber-700 dark:text-amber-300">
        &quot; {truncatedText} &quot;
      </p>
      <button
        onClick={onClose}
        className="hover:text-foreground shrink-0 touch-manipulation rounded-full p-1.5 transition-colors hover:bg-amber-200 dark:hover:bg-amber-700"
        aria-label="Remove selected text"
      >
        <IconX size={16} />
      </button>
    </motion.div>
  )
}
